import { Component, HostListener, OnDestroy, OnInit  } from '@angular/core';

import { Subscription, Subject, takeUntil } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { TriggerAction } from '@shared/actions';
import { ButtonOutline } from '@shared/buttons/button-outline/button-outline.data';
import { StateManagerProjectService } from '@state-manager/state-manager-project.service';
import { ExitActionService } from './exit-action.service';
import { ROLE } from '@shared/helpers/constants';
import { TimeTrackerService } from '@viewer/services';

@Component({
  selector: 'app-exit-action',
  templateUrl: 'exit-action.component.html',
  styleUrls: ['exit-action.component.scss'],
})
export class ExitActionComponent implements OnInit, OnDestroy{
  public isManagerRole = false;
  private _unsubscribe$ = new Subject();

  @HostListener('window:beforeunload', ['$event'])
  _closeWindowCallback($event) {
    console.log('window:beforeunload on page close/reload', $event);
    /** 
     *Instructs browser to display a confirmation dialog to the user
      if (this._stateManagerProjectService.isChangesBetweenMasks) {
        $event.stopPropagation();
        $event.returnValue = false;
      } 
    */
    if (this._subscribtionToExit === null) {
      this._subscribtionToExit =
        this._exitActionService.sendExitToBackend(false);
    }
  }

  @HostListener('window:popstate', ['$event'])
  _stopReviewTimer($event) {
    if (
      this._stateManagerProjectService.isDisabledAllToolsForChangeMask ||
      !this._stateManagerProjectService.isChangesBetweenMasks ||
      this._stateManagerProjectService.isAlreadyClosedApp || !this._stateManagerProjectService.isViewerLoaded
    ) {
      this._timeTrackerService.destroy();
    }
    }

  readonly ButtonOutline = ButtonOutline;

  public exitAction: TriggerAction;

  private _subscribtionToExit: Subscription | null = null;

  constructor(
    public _stateManagerProjectService: StateManagerProjectService,
    private _exitActionService: ExitActionService,
    private _timeTrackerService: TimeTrackerService,
    private router: Router
  ) {
    this.exitAction = new TriggerAction('', 'Actions.EXIT', () => {
      if (
        this._stateManagerProjectService.isDisabledAllToolsForChangeMask ||
        !this._stateManagerProjectService.isChangesBetweenMasks
      ) {
        this._subscribtionToExit =
          this._exitActionService.sendExitToBackend(true);
      } else {
        this._exitActionService.openConfirmDialog();
      }
    });
  }

  ngOnInit(): void {
    this.isManagerRole = JSON.parse(
      localStorage.getItem('userDetails') || '{}'
    ).userRole === ROLE.SNN_HIL_MANAGER;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next(undefined);
    this._unsubscribe$.complete();
  }

}
